import styled, { css } from 'styled-components';
import { flexCenterVertical, when } from '@stylesheets/helpers';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;

  ${({ withIdentation, theme: { spacing } }) => css`
    gap: ${spacing.level3};
    padding: ${spacing.level3} ${spacing.level5};

    ${when(
      withIdentation,
      `
        padding-left: ${spacing.level7};
      `,
    )}
  `}
`;

export const LeftColumn = styled.div`
  ${flexCenterVertical}
  flex: 1;
  display: flow;
  overflow-wrap: anywhere;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level3} 0px ${spacing.level1};
  `}
`;

export const RightColumn = styled.div`
  ${flexCenterVertical}
  max-width: 50%;
`;
